import React, { useContext, } from 'react'
import { UnitContext } from '../../App';
import { Loading } from '@sede-enterprise/shell-ds-react-framework';
import CLDetailsScreen from './CLDetailsScreen';
import useLogReport from '../../util/hooks/useLogReport';
import useFetchCLDetails from './hooks/useFetchCLDetails';


const CLDetailsContainer = (props) => {
    const unitContext = useContext(UnitContext);
    const { match } = props;


    const { corrosionLoopData, siteValue, clLocationData } = useFetchCLDetails(decodeURIComponent(match.params.id));

    // Log report for the page
    useLogReport('CORROSION LOOP DETAIL');

    const loadingScreen = (
        <div className="sensor-details-loading loading-container" role='status'>
            <Loading />
        </div>
    );
    
    if (!corrosionLoopData || !siteValue) return loadingScreen;

    return (
        <CLDetailsScreen
            units={unitContext.units}
            equipmentId={clLocationData?.equipment}
            corrosionLoopID={decodeURIComponent(match.params.id)}
            site={siteValue}
            prodUnit={clLocationData?.plant}
            location={clLocationData}
        />
    )
}

export default CLDetailsContainer